/*
 * assets/js/src/hero.js — střídání dlaždic programů v hrdinovi HP (`.promo`).
 *
 * Přeneseno z inline skriptu `navrh-mix.html`: jedna dlaždice nese `.on`,
 * po 5,2 s se posune o jednu dál, šipky přepínají ručně a tečky ukazují,
 * kolikátá je vidět.
 *
 * ---------------------------------------------------------------------
 * STAV JE V DOM, NE JEN V PROMĚNNÉ
 * ---------------------------------------------------------------------
 * Neviditelná dlaždice dostane `aria-hidden="true"` a její odkaz
 * `tabindex="-1"`. Bez toho by čtečka četla všech pět programů za sebou
 * a tabulátor by procházel čtyři odkazy, které na obrazovce nejsou —
 * návrh na to nemyslí, protože dlaždice jen zprůhledňuje. `opacity: 0`
 * prvek z přístupnostního stromu neodebírá.
 *
 * ---------------------------------------------------------------------
 * RESPEKT K `prefers-reduced-motion`
 * ---------------------------------------------------------------------
 * Při `reduce` se NESTŘÍDÁ vůbec: zůstane první dlaždice a šipky dál
 * fungují. Pohyb, který si uživatel vypnul, se nevrací časovačem.
 *
 * Automatické střídání se taky zastaví, dokud má někdo fokus uvnitř
 * panelu nebo na něm drží myš — jinak by dlaždice zmizela pod kurzorem
 * uprostřed čtení. Návrh zastavení nemá; je to NAD RÁMEC návrhu.
 */

const INTERVAL = 5200;

/**
 * Nastaví viditelnou dlaždici a dorovná stav pro čtečku i tečky.
 *
 * @param {Element[]} slidy Všechny dlaždice.
 * @param {Element[]} tecky Tečky pod panelem (může být prázdné).
 * @param {number}    index Index dlaždice, která má být vidět.
 */
function ukaz(slidy, tecky, index) {
	for (let i = 0; i < slidy.length; i += 1) {
		const aktivni = i === index;
		slidy[i].classList.toggle('on', aktivni);
		if (aktivni) slidy[i].removeAttribute('aria-hidden');
		else slidy[i].setAttribute('aria-hidden', 'true');
		for (const a of slidy[i].querySelectorAll('a, button')) {
			if (aktivni) a.removeAttribute('tabindex');
			else a.setAttribute('tabindex', '-1');
		}
	}
	for (let i = 0; i < tecky.length; i += 1) {
		tecky[i].classList.toggle('on', i === index);
	}
}

/**
 * Spustí modul. Vrací počet obsloužených panelů — stejný kontrakt jako
 * ostatní moduly, aby šlo doložit „běží nad tím jedna obsluha".
 *
 * @returns {number}
 */
export function init() {
	const panely = [...document.querySelectorAll('.hero .promo')];
	if (!panely.length) return 0;

	const klid = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	let pocet = 0;
	for (const panel of panely) {
		if (panel.dataset.za2026Hero === '1') continue;
		const slidy = [...panel.querySelectorAll('.pslide')];
		if (slidy.length < 2) continue;
		panel.dataset.za2026Hero = '1';
		pocet += 1;

		const tecky = [...panel.querySelectorAll('.pdot')];
		let index = Math.max(0, slidy.findIndex((el) => el.classList.contains('on')));
		let casovac = null;
		let stoji = klid;

		ukaz(slidy, tecky, index);

		const posun = (o) => {
			index = (index + o + slidy.length) % slidy.length;
			ukaz(slidy, tecky, index);
		};

		const tik = () => {
			if (!stoji) posun(1);
		};

		const prev = panel.querySelector('.pprev');
		const next = panel.querySelector('.pnext');
		// Ruční přepnutí posune i další automatický krok, aby dlaždice
		// nezmizela hned po kliknutí.
		const rucne = (o) => {
			posun(o);
			if (casovac !== null) {
				window.clearInterval(casovac);
				casovac = window.setInterval(tik, INTERVAL);
			}
		};
		if (prev) prev.addEventListener('click', () => rucne(-1));
		if (next) next.addEventListener('click', () => rucne(1));

		if (klid) continue;

		panel.addEventListener('mouseenter', () => { stoji = true; });
		panel.addEventListener('mouseleave', () => { stoji = false; });
		panel.addEventListener('focusin', () => { stoji = true; });
		panel.addEventListener('focusout', () => { stoji = false; });

		casovac = window.setInterval(tik, INTERVAL);
	}
	return pocet;
}
